import PropTypes from 'prop-types'

// Utils
import convertDataToContent from '../../utils/data/convertDataToContent'

const DetailBlock = (props) => {
  const { data, content, modifiers } = props
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const parseHtml = (content) => {
    const parsedContent = (content || '').replace('<h3><br /></h3>', '')
    return { __html: parsedContent }
  }

  const getHtml = () => {
    const source = data && !content ? convertDataToContent(data) : content
    return parseHtml(source && typeof source === 'object' ? source.html : source)
  }

  return <div className={`DetailBlock${modifierClasses}`} dangerouslySetInnerHTML={getHtml()} />
}

DetailBlock.propTypes = {
  data: PropTypes.array,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  modifiers: PropTypes.array
}

export default DetailBlock
